import { DS_GRID_LAYOUT_DISTRIBUTION, DSGridLayoutDistribution } from "../types/modes";

export const DISTRIBUTION_TO_CLASS_MAP: Record<DSGridLayoutDistribution, string> = {
  [DS_GRID_LAYOUT_DISTRIBUTION.Cols1]: "ds-grid__layout--cols-1",
  [DS_GRID_LAYOUT_DISTRIBUTION.Cols2]: "ds-grid__layout--cols-2",
  [DS_GRID_LAYOUT_DISTRIBUTION.Cols4]: "ds-grid__layout--cols-4",
  [DS_GRID_LAYOUT_DISTRIBUTION.Cols6]: "ds-grid__layout--cols-6",
  [DS_GRID_LAYOUT_DISTRIBUTION.Split]: "ds-grid__layout--split",
  [DS_GRID_LAYOUT_DISTRIBUTION.Split12]: "ds-grid__layout--split-1-2",
  [DS_GRID_LAYOUT_DISTRIBUTION.Split21]: "ds-grid__layout--split-2-1",
} as const;
